import React, { useEffect } from "react";
import logo from "../static/img/quindl_logo.png";
import "../static/css/Nav.css";

const Nav = () => {
  useEffect(() => {
    const handleToggle = () => {
      const menu = document.querySelector(".menu");
      const toggleIcon = document.querySelector(".toggle ion-icon");

      if (menu.classList.contains("active")) {
        menu.classList.remove("active");
        toggleIcon.setAttribute("name", "menu-outline");
      } else {
        menu.classList.add("active");
        toggleIcon.setAttribute("name", "close-outline");
      }
    };

    const toggleButton = document.querySelector(".toggle");
    toggleButton.addEventListener("click", handleToggle);

    return () => {
      toggleButton.removeEventListener("click", handleToggle);
    };
  }, []);

  const reloadPage = () => {
    window.location.reload();
  };

  return (
    <nav>
      <div className="logo">
        <button onClick={reloadPage} className="link-button">
          <img src={logo} alt="Logo" />
        </button>
      </div>
      <div className="toggle">
        <button className="link-button">
          <ion-icon name="menu-outline"></ion-icon>
        </button>
      </div>
      <ul className="menu">
        <li>
          <button onClick={reloadPage} className="link-button">
            Events
          </button>
        </li>
        <li>
          <a href="https://quindl.com/services">Services</a>
        </li>
        <li>
          <a href="https://quindl.com/aboutus">About Us</a>
        </li>
        <li>
          <a href="https://quindl.com/contactus" className="right">
            Contact Us
          </a>
        </li>
      </ul>
    </nav>
  );
};

export default Nav;
